export enum OcTerminationCreationWay {
    Calculation = "Calculation",
    Manual = "Manual",
}